import { BlockParameters, PipelinePhase } from '@visualizer/types';
import { AddMetadata, BlockKeys } from '../BlockCatalog';
import { PipelineBlock } from '../PipelineBlock';
import RemoveSensorsByIdStage, { RemoveSensorsByIdStageParameters } from '../stages/filters/RemoveSensorsByIdStage';

export interface RemoveSensorsByIdBlockParameters extends BlockParameters, RemoveSensorsByIdStageParameters {}

@AddMetadata({
    type: BlockKeys.RemoveSensorsById,
    name: 'Remove Sensors By ID',
    description: 'Filters Sensor Points inside DesignSchemes',
    visible: false,
    pipelinePhase: PipelinePhase.Post,
})
class RemoveSensorsByIdBlock extends PipelineBlock<RemoveSensorsByIdBlockParameters> {
    constructor(params: RemoveSensorsByIdBlockParameters, stringId?: string) {
        super(params, stringId);
    }

    protected override serializeParams(): RemoveSensorsByIdBlockParameters {
        return {
            ...this.getParams(),
            sensorIds: this.getParams().sensorIds,
            isInverted: this.getParams().isInverted,
        };
    }

    protected override defineStages() {
        const { sensorIds, isInverted } = this.getParams();
        const normalizedSensorIds: Set<number> =
            sensorIds instanceof Set
                ? new Set<number>(Array.from(sensorIds).filter((id): id is number => typeof id === 'number'))
                : new Set<number>();
        return [
            new RemoveSensorsByIdStage({
                sensorIds: normalizedSensorIds,
                isInverted,
            }),
        ];
    }
}

export default RemoveSensorsByIdBlock;
